<script>
import PrescriptionPad from '../components/PrescriptionPad.vue';

export default {
  name: 'RegisterPrescription',
  components: {
    PrescriptionPad,
  },
  data() {
    return {
      prescriptionText: 'Ozempic',
    };
  },
};
</script>

<template>
  <PrescriptionPad :prescriptionText="prescriptionText" />
</template>
